import { createStore } from "vuex"
import copy from '../static/copy.json'
import questions from '../static/data.json'

const store = createStore({
    state: {
        answers: [],
        showAnswers: false,
        previousQuestion: [],
        copy: copy,
        questions: questions,
        language: 'en',
        current: 1,
        path: [ 1 ]
    },
    mutations: {
        add ( state, result ) {

            state.answers = state.answers.filter(
                ( answer ) => answer.id < result.id
            )

            state.answers.push( result )
        },
        reset ( state ) {
            state.answers = []
        },
        show ( state ) {
            state.showAnswers = true
        },
        hide ( state ) {
            state.showAnswers = false
        },
        update ( state, number ) {
            state.current = number
        },
        previous ( state ) {

            state.path = state.path.filter(
                ( item ) => item < state.current
            )

            state.current = state.path.slice( -1 ).pop()

        },
        updateprev ( state, number ) {

            state.path = state.path.filter(
                ( item ) => item < number
            )

            state.path.push( number )
        }
    }
} )

export default store;